<template>
  <div>
    <div class="container" v-if="layoutType === 'tablet'">
      <WizardAlert v-if="showWizard && !currentUserIsWatcher" class="mb-12"/>
      <AddOperationWidget v-if="!currentUserIsWatcher" @updateDashboard="updateDashboardData"/>
    </div>
    <OfficeLayout>
      <div>
        <MyAccounts/>
        <MyBudgets/>
        <MyInvestmentPortfolios/>
      </div>
      <div>
        <template v-if="layoutType === 'desktop'">
          <WizardAlert v-if="showWizard && !currentUserIsWatcher" class="mb-12"/>
          <AddOperationWidget v-if="!currentUserIsWatcher" @updateDashboard="updateDashboardData"/>
        </template>
        <PlannedTransactions v-if="transactions.length" @updateDashboard="updateDashboardData"/>
        <RecentTransactions @updateDashboard="updateDashboardData"/>
      </div>
    </OfficeLayout>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import MyAccounts from '@/components/cabinet/Money/Dashboard/MyAccounts/MyAccounts.vue';
import MyBudgets from '@/components/cabinet/Money/Dashboard/MyBudgets/MyBudgets.vue';
import MyInvestmentPortfolios
  from '@/components/cabinet/Money/Dashboard/MyInvestmentPortfolios/MyInvestmentPortfolios.vue';
import RecentTransactions from '@/components/cabinet/Money/Dashboard/RecentTransactions/RecentTransactions.vue';
import OfficeLayout from "@/components/layouts/cabinet/OfficeLayout";
import BaseButton from "@/components/UI/BaseButton";
import WizardAlert from "@/components/cabinet/Wizard/WizardAlert";
import AddOperationWidget from "@/components/cabinet/Money/Dashboard/AddOperation/AddOperationWidget";
import PlannedTransactions from "@/components/cabinet/Money/Dashboard/PlannedTransactions/PlannedTransactions";


export default {
  name: "TheOffice",
  components: {
    PlannedTransactions,
    AddOperationWidget,
    WizardAlert,
    BaseButton,
    OfficeLayout,
    MyAccounts,
    MyBudgets,
    MyInvestmentPortfolios,
    RecentTransactions,
  },
  computed: {
    ...mapGetters('theme', ['layoutType']),
    ...mapGetters('space', ['currentUserIsWatcher']),
    ...mapGetters('cabinet/user', ['showWizard']),
    ...mapGetters('moneyDashboard/plannedTransactions', ['transactions'])
  },
  methods: {
    updateDashboardData() {
      this.$store.dispatch('space/accounts/getAccounts');
      this.$store.dispatch('space/accounts/getAccountGroups');
      this.$store.dispatch('moneyDashboard/recentTransactions/getRecentTransactions');
      this.$store.dispatch('moneyDashboard/plannedTransactions/getPlannedTransactions');
      this.$store.dispatch('moneyDashboard/budgetWidget/fetchWidgetData');
    }
  },
  mounted() {
    this.updateDashboardData()
    this.$store.dispatch('space/incomes/getIncomes');
    this.$store.dispatch('space/expenses/getExpenses');
    this.$store.dispatch('space/expenses/getExpenseGroups');
    this.$store.dispatch('space/tags/getTags');
    this.$store.dispatch('space/contractors/getContractors');
    this.$store.dispatch('space/banks/fetchProviders');
  }
}
</script>
